export class BnplModel {
  public totalAmount: string = '';
  public downPayment: boolean = false;
}
